module.exports = __webpack_public_path__ + "static/img/recommend.5745ca32.png";